import { Injectable } from '@angular/core';
import { gql, Query } from 'apollo-angular';

import { CUSTOM_LINE_FRAGMENT } from 'graphql/fragments/custom-line';
import { OFFER_BASE_FRAGMENT } from 'graphql/fragments/offer-base';
import { PRODUCT_LINE_FRAGMENT } from 'graphql/fragments/product-line';
import { PRODUCT_LINE_PRODUCT_FRAGMENT } from 'graphql/fragments/product-line-product';
import { QUOTE_PRICING_FRAGMENT } from 'graphql/fragments/quote-pricing';
import { Query as RootQuery } from 'graphql/models/generated';

export const OFFER_QUERY = gql`
  query quoteWithLines(
    $documentVersion: DocumentVersionInput!
    ) {
    quotes {
      quote(documentVersion: $documentVersion) {
        ...OfferBaseFragment
        linesCount
        lines {
          ...ProductLineFragment
          ...ProductLineProductFragment
          ...CustomLineFragment
        }
        ...QuotePricingFragment
      }
    }
  }
  ${OFFER_BASE_FRAGMENT}
  ${PRODUCT_LINE_FRAGMENT}
  ${PRODUCT_LINE_PRODUCT_FRAGMENT}
  ${CUSTOM_LINE_FRAGMENT}
  ${QUOTE_PRICING_FRAGMENT}
`;

@Injectable({
  providedIn: 'root'
})
export class OfferQuery extends Query<RootQuery> {
  document = OFFER_QUERY;
}
